import React from 'react';
import { Chart, Line, Axis, Area, Tooltip, Coordinate, Annotation } from 'bizcharts';
import {IUScoreItem} from '..';

// const data = [
//     { item: '课程结构', score: 70, max: 100 },
//     { item: '学习内容', score: 60, max: 100 },
//     { item: '练习与反馈', score: 50, max: 100 },
//     { item: '课程互动性', score: 40, max: 100 },
//     { item: '课程吸引力', score: 60, max: 100 },
// ];
const OffsetList = [
    { x: -140, y: -36 },
    { x: 4, y: 4 },
    { x: 0, y: 16 },
    { x: -97, y: 16 },
    { x: -90, y: 4 },
];
interface IProps {
    color?: string;
    uScoreItems: IUScoreItem[];
    score:number;
}
const MAX_SCORE = 100;
export function UCourseRadar(props: IProps) {
    const { color = '#FFC748', uScoreItems,score=0 } = props;

    const chartData = uScoreItems.map((item) => {
        return {
            item: item.name,
            score: item.score,
            max: MAX_SCORE,
        };
    });
    return (
        <Chart
            height={182}
            width={280}
            data={chartData}
            autoFit
            scale={{
                score: {
                    min: 0,
                    max: MAX_SCORE,
                },
                max: {
                    min: 0,
                    max: MAX_SCORE,
                },
            }}
            animate={false}
        >
            <Coordinate type="polar" radius={0.6} />
            <Tooltip visible={false} />
            <Line
                position="item*max"
                style={{
                    stroke: color,
                    lineWidth: 2,
                    opacity: 0.24,
                }}
                size={2}
            />
            <Area position="item*score" color={color} />
            <Axis name="score" visible={false} />
            <Axis name="max" visible={false} />
            <Axis
                grid={{
                    line: {
                        style: {
                            stroke: color,
                            lineWidth: 2,
                            opacity: 0.24,
                        },
                    },
                }}
                name="item"
                line={false}
                tickLine={false}
                label={{
                    offset: 12,
                    style: {
                        textAlign: 'center', // 文本对齐方向，可取值为： start center end
                        fill: color, // 文本的颜色
                        fontSize: 16, // 文本大小
                        fontWeight: 'bold', // 文本粗细
                        textBaseline: 'middle',
                    },
                    formatter(_text, _item, index) {
                        return chartData[index].score;
                    },
                }}
            />
            {chartData.map((item, index) => {
                const isFirst = index === 0;
                const rightItemsIndex = [3, 4]; // 第四个第五个要特殊处理
                return (
                    <Annotation.Html
                        html={`<div style='font-size:12px;color:#222222;${
                            isFirst ? 'width:280px;text-align:center;' : 'width:84px;'
                        } ${rightItemsIndex.includes(index) ? 'text-align:right;' : ''} word-wrap: normal;'>${
                            item.item
                        }</div>`}
                        key={index}
                        position={[index, 'max']}
                        offsetX={OffsetList[index].x}
                        offsetY={OffsetList[index].y}
                    />
                );
            })}
            <Annotation.Html
                html={`<div style='color:#222222;font-weight:700;'><span style='font-size:16px;'>${score}</span>/100</div>`}
                offsetX={-20}
                offsetY={-14}
                position={[0, 0]}
            />
        </Chart>
    );
}
